module.exports = __webpack_public_path__ + "static/media/feature0_bg.ad5b4b26.png";